import styled, { css } from 'styled-components';
import { IButtonProps } from '../eventToolbox/EventToolbox.styles';
import theme from 'src/theme';

export const NodeWrapper = styled.div``;

export const IconWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: calc(50% - 8px);
    right: 3px;
    border-radius: 50%;
    height: 15px;
`;

export const MoveButton = styled.button<IButtonProps>`
    cursor: pointer;

    &.is-moved-to {
        position: absolute;
        top: calc(50% - 9px);
        right: 40px;
        background: ${theme.colors.background.transparent};
        color: ${theme.colors.text.purple};
        font-size: 0.9rem;
    }

    ${({ isSelected }) =>
        isSelected &&
        css`
            background: red;
            border: red;
            color: #fff;
        `}
`;

export const MovedDeletedIcon = styled.button<IButtonProps>`
    cursor: pointer;

    ${({ isSelected }) =>
        isSelected &&
        css`
            background: red;
            border: red;
            color: #fff;
        `}
`;

export const Wrapper = styled.div`
    height: 100%;
    overflow: hidden;
    width: 100%;
    border-right: 1px solid ${({ theme }) => theme.colors.border.ddd};

    .rotation-parent-node {
        &.closed-tree-node {
            .berth-node {
                display: none;
            }
        }
    }

    .rotation-tree-list {
        height: calc(100% - 60px);
        max-height: 100%;
        overflow: auto;
    }

    .rotation-node {
        margin: 2px 0;
        position: relative;

        &.port-node {
            border-left: 5px solid ${({ theme }) => theme.colors.rotationTree.portNode.border};
            color: ${({ theme }) => theme.colors.rotationTree.nodeText};
            font-weight: 700;
            font-size: 0.9rem;
            &.is-at-sea {
                border-left: 5px solid ${({ theme }) => theme.colors.rotationTree.portNode.atSea};
            }
            &:hover {
                background: #eee;
            }
        }

        &.berth-node {
            background: #f8f8f8;
            font-size: 0.85rem;
            font-weight: 500;
            &:hover {
                background: #eee;
            }
        }

        &.cargo-node {
            background: ${theme.colors.background.rotationTree.item};
            font-size: 0.75rem;
            font-weight: 400;
            padding-left: 5px;
            &:hover {
                background: #eee;
            }
        }

        .rotation-name {
            cursor: pointer;
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            border-bottom: 1px solid #ddd;
            position: relative;
            border: 0;
            text-align: left;
            color: #04265a;
            padding: 0.5rem 4rem 0.5rem 0.5rem;
            box-shadow: 0 5px 5px -3px #ddd;
            border-bottom: 1px solid #ddd;
        }

        &.is-selected {
            > .rotation-name {
                background: ${theme.legacyColors.selectedBackground};
                border: 1px solid #${theme.legacyColors.selectedBorder};
                color: ${theme.legacyColors.selectedColor};
            }
        }

        .has-delivery-in-port,
        .is-priority-port {
            position: absolute;
            font-size: 0.75rem;
        }

        .is-priority-port {
            right: 2px;
            top: -10px;
            font-size: 0.65rem;
        }

        .is-manual-berth {
            background: pink;
        }

        .updated-by-operator {
            top: 12px;
            right: -2px;
            left: auto;
        }

        .is-in-port-cluster {
            font-size: 0.65rem;
            margin: 0 0 0 5px;
        }

        &.is-moved-to-node {
            > .rotation-name {
                border: 2px dashed ${({ theme }) => theme.colors.rotationTree.movedToBorder} !important;
                cursor: pointer;
                background: transparent;
                font-size: 0.85rem;
            }
        }

        .edit-icon {
            position: absolute;
            top: calc(50% - 8px);
            right: 5px;
            border-radius: 50%;
            width: 15px;
            height: 15px;
            font-size: 1rem;
        }

        .move-icon {
            position: absolute;
            top: calc(50% - 9px);
            right: 50px;
            background: ${theme.colors.background.transparent};
            color: ${theme.colors.text.purple};
            font-size: 0.9rem;
            span {
                border-radius: 50%;
                width: 15px;
                height: 15px;
                font-size: 0.9rem;
                padding: 0 1px;
                display: block;
                color: purple;
                border: 0;
                background: #fff;
                svg {
                    vertical-align: 1px;
                }
            }
        }

        .is-moved-icon {
            position: absolute;
            top: calc(50% - 5px);
            right: 25px;
            border-radius: 50%;
            width: 15px;
            height: 15px;
            padding: 0 0px;
            color: ${theme.colors.text.khaki};
        }

        .is-deleted-icon {
            position: absolute;
            top: calc(50% - 5px);
            right: 23px;
            border-radius: 50%;
            width: 15px;
            height: 15px;
            padding: 0 0px;
            color: ${theme.colors.text.pink};
        }

        .deleted-rotation-item {
            svg {
                fill: black;
                color: #fff;
            }
        }

        .edited-rotation-item {
            svg {
                fill: #e65100;
                color: #fff;
            }
        }
    }
`;
